import * as React from "react";
import type { SVGProps } from "react";
const SvgAdvantageCheckIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      stroke="#18A09F"
      strokeLinecap="square"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M20 6 9 17l-5-5"
    />
  </svg>
);
export default SvgAdvantageCheckIcon;
